import { create } from "zustand";
import { getPanelTokens, panelApi, setPanelTokens } from "@/admin/lib/panelApi";
import type { LoginResponse, PanelUser } from "@/admin/types";

interface AuthState {
  user: PanelUser | null;
  initialized: boolean;
  login: (email: string, password: string, totpCode?: string) => Promise<void>;
  logout: () => Promise<void>;
  fetchMe: () => Promise<void>;
  bootstrap: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  initialized: false,

  login: async (email, password, totpCode) => {
    const payload: Record<string, string> = { email, password };
    if (totpCode) payload.totp_code = totpCode;
    const { data } = await panelApi.post<LoginResponse>("/auth/login/", payload);
    setPanelTokens(data.access, data.refresh);
    set({ user: data.user });
  },

  logout: async () => {
    const { refresh } = getPanelTokens();
    try {
      if (refresh) await panelApi.post("/auth/logout/", { refresh });
    } finally {
      setPanelTokens(null, null);
      set({ user: null });
    }
  },

  fetchMe: async () => {
    const { data } = await panelApi.get<PanelUser>("/auth/me/");
    set({ user: data });
  },

  bootstrap: async () => {
    const tokens = getPanelTokens();
    if (!tokens.access) {
      set({ initialized: true, user: null });
      return;
    }
    try {
      const { data } = await panelApi.get<PanelUser>("/auth/me/");
      set({ user: data, initialized: true });
    } catch {
      setPanelTokens(null, null);
      set({ user: null, initialized: true });
    }
  },
}));
